<template>
    <div>
        <DCard
            padding
        >
            <CronJobForm
                :errors="errors"
                :cron-job="cronJob"
                :cron-job-list="cronJobList"
                @form-submitted="updateCronJob"
            />
        </DCard>
    </div>
</template>

<script>
import CronJobForm from '~@/Components/Administrations/CronJobs/Form'
export default {
    name: 'EditCronJob',
    components: { CronJobForm },
    props: {
        errors: {
            type: Object,
            default: () => { return {} }
        },
        cronJob: {
            type: Object,
            default: () => { return {} }
        },
        cronJobList: {
            type: Array,
            default: () => { return [] }
        }
    },
    methods: {
        updateCronJob (form) {
            form.put(this.$route('administrations.cron-jobs.update', {
                cron_job: this.cronJob.id
            }))
        }
    }
}
</script>

<style scoped>

</style>
